/* AUTO-GENERATED, DO NOT MODIFY MANUALLY, RUN `pnpm codegen` INSTEAD */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Asset = {
  __typename?: 'Asset';
  content: Scalars['String']['output'];
  fromProvider: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  imageAspectRatio?: Maybe<Scalars['String']['output']>;
  imageQualifier?: Maybe<Scalars['String']['output']>;
  originalType?: Maybe<Scalars['String']['output']>;
  present: Scalars['Boolean']['output'];
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AssetInput = {
  content: Scalars['String']['input'];
  imageAspectRatio?: InputMaybe<Scalars['String']['input']>;
  imageQualifier?: InputMaybe<Scalars['String']['input']>;
  originalAssetId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type AssetUploadInput = {
  assetId: Scalars['String']['input'];
  currentVersion: Scalars['Int']['input'];
  imageAspectRatio?: InputMaybe<Scalars['String']['input']>;
  targetFilename: Scalars['String']['input'];
  type: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type Audience = {
  __typename?: 'Audience';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BatchUpdateFailure = {
  __typename?: 'BatchUpdateFailure';
  assetId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type BatchUpdateResult = {
  __typename?: 'BatchUpdateResult';
  failed: Array<BatchUpdateFailure>;
  updated: Array<Scalars['String']['output']>;
};

export type Category = {
  __typename?: 'Category';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type DeviceType = {
  __typename?: 'DeviceType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DiffLine = {
  __typename?: 'DiffLine';
  op: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type EditorialInput = {
  actors?: InputMaybe<Array<Scalars['String']['input']>>;
  actorsDisplay?: InputMaybe<Scalars['String']['input']>;
  assets?: InputMaybe<Array<AssetInput>>;
  audience?: InputMaybe<Scalars['String']['input']>;
  availableInLocalities?: InputMaybe<Array<Scalars['String']['input']>>;
  billingId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  director?: InputMaybe<Array<Scalars['String']['input']>>;
  displayRunTime?: InputMaybe<Scalars['String']['input']>;
  episodeId?: InputMaybe<Scalars['String']['input']>;
  episodeName?: InputMaybe<Scalars['String']['input']>;
  episodeOrdinal?: InputMaybe<Scalars['String']['input']>;
  genre?: InputMaybe<Array<Scalars['String']['input']>>;
  grossPrice?: InputMaybe<Scalars['String']['input']>;
  hdContent?: InputMaybe<Scalars['String']['input']>;
  licensingWindowEnd?: InputMaybe<Scalars['String']['input']>;
  licensingWindowStart?: InputMaybe<Scalars['String']['input']>;
  localityProperties?: InputMaybe<LocalityPropertiesInput>;
  maximumViewingLength?: InputMaybe<Scalars['String']['input']>;
  netPrice?: InputMaybe<Scalars['String']['input']>;
  producers?: InputMaybe<Array<Scalars['String']['input']>>;
  rating?: InputMaybe<Array<Scalars['String']['input']>>;
  restrictedDeviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  runTime?: InputMaybe<Scalars['String']['input']>;
  seriesOrdinal?: InputMaybe<Scalars['String']['input']>;
  showType?: InputMaybe<Scalars['String']['input']>;
  studio?: InputMaybe<Scalars['String']['input']>;
  studioCode?: InputMaybe<Scalars['String']['input']>;
  studioName?: InputMaybe<Scalars['String']['input']>;
  suggestedPrice?: InputMaybe<Scalars['String']['input']>;
  summaryLong?: InputMaybe<Scalars['String']['input']>;
  summaryMedium?: InputMaybe<Scalars['String']['input']>;
  summaryShort?: InputMaybe<Scalars['String']['input']>;
  targetPlatforms?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleBrief?: InputMaybe<Scalars['String']['input']>;
  titleSortName?: InputMaybe<Scalars['String']['input']>;
  writerDisplay?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type ExportInput = {
  assetId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type ExportRejection = {
  __typename?: 'ExportRejection';
  assetId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type ExportResult = {
  __typename?: 'ExportResult';
  accepted: Array<Scalars['String']['output']>;
  rejected: Array<ExportRejection>;
};

export type Facet = {
  __typename?: 'Facet';
  count: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type Facets = {
  __typename?: 'Facets';
  genre: Array<Facet>;
  language: Array<Facet>;
  provider: Array<Facet>;
  showType: Array<Facet>;
  state: Array<Facet>;
  validationLevel: Array<Facet>;
};

export type FileUrlRequest = {
  assetId: Scalars['String']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type FileUrlResponse = {
  __typename?: 'FileUrlResponse';
  filename: Scalars['String']['output'];
  targetFilename: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type Genre = {
  __typename?: 'Genre';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Item = {
  __typename?: 'Item';
  assetId: Scalars['String']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  editVersion: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  exportKey?: Maybe<Scalars['String']['output']>;
  exportedAt?: Maybe<Scalars['String']['output']>;
  media: Array<Media>;
  properties: ItemProperties;
  provider: Scalars['String']['output'];
  providerId?: Maybe<Scalars['String']['output']>;
  sourceKey?: Maybe<Scalars['String']['output']>;
  state: ItemState;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  validations: Array<Validation>;
  version: Scalars['String']['output'];
  worstValidationLevel?: Maybe<ValidationLevel>;
  xmlFilename?: Maybe<Scalars['String']['output']>;
  xmlVersion?: Maybe<Scalars['String']['output']>;
};

export type ItemFilters = {
  genre?: InputMaybe<Array<Scalars['String']['input']>>;
  ingestedAfter?: InputMaybe<Scalars['String']['input']>;
  ingestedBefore?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Array<Scalars['String']['input']>>;
  provider?: InputMaybe<Array<Scalars['String']['input']>>;
  showType?: InputMaybe<Array<Scalars['String']['input']>>;
  state?: InputMaybe<Array<ItemState>>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  validationLevel?: InputMaybe<Array<ValidationLevel>>;
};

export type ItemProperties = {
  __typename?: 'ItemProperties';
  actors: StringListField;
  actorsDisplay: StringField;
  assets: Array<Asset>;
  audience: StringField;
  audioType: StringField;
  availableInLocalities: StringListField;
  billingId: StringField;
  category: LocalityStringListField;
  countryOfOrigin: StringField;
  director: StringListField;
  displayRunTime: StringField;
  episodeId: StringField;
  episodeName: StringField;
  episodeOrdinal: StringField;
  genre: StringListField;
  grossPrice: LocalityStringField;
  hdContent: StringField;
  languages: StringListField;
  licensingWindowEnd: LocalityStringField;
  licensingWindowStart: LocalityStringField;
  maximumViewingLength: StringField;
  netPrice: LocalityStringField;
  packageOfferId: LocalityStringListField;
  producers: StringListField;
  rating: StringListField;
  restrictedDeviceTypes: StringListField;
  runTime: StringField;
  seriesOrdinal: StringField;
  showType: StringField;
  studio: StringField;
  studioCode: StringField;
  studioName: StringField;
  suggestedPrice: StringField;
  summaryLong: StringField;
  summaryMedium: StringField;
  summaryShort: StringField;
  targetPlatforms: StringListField;
  title: StringField;
  titleBrief: StringField;
  titleSortName: StringField;
  writerDisplay: StringField;
  year: StringField;
};

export enum ItemState {
  ExportCompleted = 'EXPORT_COMPLETED',
  ExportFailed = 'EXPORT_FAILED',
  ExportRequested = 'EXPORT_REQUESTED',
  Modified = 'MODIFIED',
  New = 'NEW',
  Rejected = 'REJECTED'
}

export type ItemUpdateInput = {
  assetId: Scalars['String']['input'];
  currentVersion: Scalars['Int']['input'];
  editorial: EditorialInput;
  version: Scalars['String']['input'];
};

export type ItemsPage = {
  __typename?: 'ItemsPage';
  items: Array<Item>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type LocalityListVariant = {
  __typename?: 'LocalityListVariant';
  editorial?: Maybe<Array<Scalars['String']['output']>>;
  locality: Scalars['String']['output'];
  original?: Maybe<Array<Scalars['String']['output']>>;
};

export type LocalityPropertiesInput = {
  category?: InputMaybe<Array<LocalityStringListInput>>;
  grossPrice?: InputMaybe<Array<LocalityStringInput>>;
  licensingWindowEnd?: InputMaybe<Array<LocalityStringInput>>;
  licensingWindowStart?: InputMaybe<Array<LocalityStringInput>>;
  netPrice?: InputMaybe<Array<LocalityStringInput>>;
  packageOfferId?: InputMaybe<Array<LocalityStringListInput>>;
};

export type LocalityStringField = {
  __typename?: 'LocalityStringField';
  default: StringField;
  variants: Array<LocalityVariant>;
};

export type LocalityStringInput = {
  locality: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LocalityStringListField = {
  __typename?: 'LocalityStringListField';
  default: StringListField;
  variants: Array<LocalityListVariant>;
};

export type LocalityStringListInput = {
  locality: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type LocalityVariant = {
  __typename?: 'LocalityVariant';
  editorial?: Maybe<Scalars['String']['output']>;
  locality: Scalars['String']['output'];
  original?: Maybe<Scalars['String']['output']>;
};

export type Media = {
  __typename?: 'Media';
  checksum: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  source: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  batchUpdateItems: BatchUpdateResult;
  deleteAudience?: Maybe<Audience>;
  deleteDeviceType?: Maybe<DeviceType>;
  deleteGenre?: Maybe<Genre>;
  deleteItem: Item;
  deleteProvider?: Maybe<Provider>;
  deleteRating?: Maybe<Rating>;
  deleteShowType?: Maybe<ShowType>;
  deleteValidationRule?: Maybe<ValidationRule>;
  exportItems: ExportResult;
  registerAssetUpload: Item;
  restoreItem: Item;
  revalidateItem: Array<Validation>;
  revertField: Item;
  revertItem: Item;
  setAudience: Audience;
  setDeviceType: DeviceType;
  setGenre: Genre;
  setProvider: Provider;
  setRating: Rating;
  setShowType: ShowType;
  setValidationRule: ValidationRule;
  updateItem: Item;
};


export type MutationBatchUpdateItemsArgs = {
  items: Array<ItemUpdateInput>;
};


export type MutationDeleteAudienceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDeviceTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGenreArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteItemArgs = {
  assetId: Scalars['String']['input'];
  currentVersion: Scalars['Int']['input'];
  version: Scalars['String']['input'];
};


export type MutationDeleteProviderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRatingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShowTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteValidationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExportItemsArgs = {
  items: Array<ExportInput>;
};


export type MutationRegisterAssetUploadArgs = {
  input: AssetUploadInput;
};


export type MutationRestoreItemArgs = {
  assetId: Scalars['String']['input'];
  currentVersion: Scalars['Int']['input'];
  version: Scalars['String']['input'];
};


export type MutationRevalidateItemArgs = {
  assetId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type MutationRevertFieldArgs = {
  assetId: Scalars['String']['input'];
  currentVersion: Scalars['Int']['input'];
  field: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type MutationRevertItemArgs = {
  assetId: Scalars['String']['input'];
  currentVersion: Scalars['Int']['input'];
  version: Scalars['String']['input'];
};


export type MutationSetAudienceArgs = {
  input: NamedInput;
};


export type MutationSetDeviceTypeArgs = {
  input: NamedInput;
};


export type MutationSetGenreArgs = {
  input: NamedInput;
};


export type MutationSetProviderArgs = {
  input: ProviderInput;
};


export type MutationSetRatingArgs = {
  input: NamedInput;
};


export type MutationSetShowTypeArgs = {
  input: ShowTypeInput;
};


export type MutationSetValidationRuleArgs = {
  input: ValidationRuleInput;
};


export type MutationUpdateItemArgs = {
  input: ItemUpdateInput;
};

export type NamedInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type Provider = {
  __typename?: 'Provider';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  providerId?: Maybe<Scalars['String']['output']>;
};

export type ProviderInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  assetUploadUrls: Array<FileUrlResponse>;
  audience?: Maybe<Audience>;
  audiences: Array<Audience>;
  categories: Array<Category>;
  deviceType?: Maybe<DeviceType>;
  deviceTypes: Array<DeviceType>;
  facets: Facets;
  genre?: Maybe<Genre>;
  genres: Array<Genre>;
  item?: Maybe<Item>;
  itemVersions: Array<Item>;
  listItems: ItemsPage;
  previewXml: Scalars['String']['output'];
  provider?: Maybe<Provider>;
  providers: Array<Provider>;
  rating?: Maybe<Rating>;
  ratings: Array<Rating>;
  searchItems: SearchResultsPage;
  showType?: Maybe<ShowType>;
  showTypes: Array<ShowType>;
  validationRules: Array<ValidationRule>;
  xmlDiff: Array<DiffLine>;
};


export type QueryAssetUploadUrlsArgs = {
  files: Array<FileUrlRequest>;
};


export type QueryAudienceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeviceTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGenreArgs = {
  id: Scalars['ID']['input'];
};


export type QueryItemArgs = {
  assetId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryItemVersionsArgs = {
  assetId: Scalars['String']['input'];
};


export type QueryListItemsArgs = {
  filters?: InputMaybe<ItemFilters>;
  limit: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewXmlArgs = {
  assetId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type QueryProviderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRatingArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchItemsArgs = {
  filters?: InputMaybe<ItemFilters>;
  limit: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
};


export type QueryShowTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryXmlDiffArgs = {
  assetId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type Rating = {
  __typename?: 'Rating';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  assetId: Scalars['String']['output'];
  posterUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  showType?: Maybe<Scalars['String']['output']>;
  state: ItemState;
  title?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
  worstValidationLevel?: Maybe<ValidationLevel>;
};

export type SearchResultsPage = {
  __typename?: 'SearchResultsPage';
  items: Array<SearchResult>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type ShowType = {
  __typename?: 'ShowType';
  id: Scalars['ID']['output'];
  isSeries?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type ShowTypeInput = {
  id: Scalars['ID']['input'];
  isSeries?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type StringField = {
  __typename?: 'StringField';
  editorial?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
};

export type StringListField = {
  __typename?: 'StringListField';
  editorial?: Maybe<Array<Scalars['String']['output']>>;
  original?: Maybe<Array<Scalars['String']['output']>>;
};

export type Validation = {
  __typename?: 'Validation';
  field: Scalars['String']['output'];
  level: ValidationLevel;
  message: Scalars['String']['output'];
  ruleId: Scalars['String']['output'];
};

export enum ValidationLevel {
  Error = 'ERROR',
  Warning = 'WARNING'
}

export type ValidationRule = {
  __typename?: 'ValidationRule';
  appliesToProvider?: Maybe<Array<Scalars['String']['output']>>;
  appliesToShowType?: Maybe<Array<Scalars['String']['output']>>;
  checkParams?: Maybe<Scalars['String']['output']>;
  checkType: Scalars['String']['output'];
  disabled?: Maybe<Scalars['Boolean']['output']>;
  field: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  level: ValidationLevel;
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ValidationRuleInput = {
  appliesToProvider?: InputMaybe<Array<Scalars['String']['input']>>;
  appliesToShowType?: InputMaybe<Array<Scalars['String']['input']>>;
  checkParams?: InputMaybe<Scalars['String']['input']>;
  checkType: Scalars['String']['input'];
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  field: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  level: ValidationLevel;
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
};
